var map = {
	".": "4360",
	"./": "4360",
	"./collection.store-partial": "ba45",
	"./collection.store-partial.js": "ba45",
	"./dynamic-collection.store-partial": "c4cf",
	"./dynamic-collection.store-partial.js": "c4cf",
	"./game": "eff3",
	"./game/": "eff3",
	"./game/balance.store": "0cb0",
	"./game/balance.store.js": "0cb0",
	"./game/bummers/big.store-partial": "ff99",
	"./game/bummers/big.store-partial.js": "ff99",
	"./game/bummers/jackpot.store-partial": "cd2d",
	"./game/bummers/jackpot.store-partial.js": "cd2d",
	"./game/bummers/list.store": "c661",
	"./game/bummers/list.store.js": "c661",
	"./game/bummers/little.store-partial": "a453",
	"./game/bummers/little.store-partial.js": "a453",
	"./game/bummers/single.store": "9c6d",
	"./game/bummers/single.store.js": "9c6d",
	"./game/bummers/trivia.store-partial": "10dc",
	"./game/bummers/trivia.store-partial.js": "10dc",
	"./game/coverage-tracker.store": "94a4",
	"./game/coverage-tracker.store.js": "94a4",
	"./game/hints.store": "e7b6",
	"./game/hints.store.js": "e7b6",
	"./game/index": "eff3",
	"./game/index.js": "eff3",
	"./game/insurance/list.store": "3d68",
	"./game/insurance/list.store.js": "3d68",
	"./game/insurance/single.store": "03f5",
	"./game/insurance/single.store.js": "03f5",
	"./game/plans/coverage.store-partial": "a10c",
	"./game/plans/coverage.store-partial.js": "a10c",
	"./game/plans/deductible.store-partial": "40be",
	"./game/plans/deductible.store-partial.js": "40be",
	"./game/plans/limit.store-partial": "e5e5",
	"./game/plans/limit.store-partial.js": "e5e5",
	"./game/plans/list.store": "5ea5",
	"./game/plans/list.store.js": "5ea5",
	"./game/plans/single.store": "1af7",
	"./game/plans/single.store.js": "1af7",
	"./game/risk.store": "716b",
	"./game/risk.store.js": "716b",
	"./game/rounds/list.store": "a3aa",
	"./game/rounds/list.store.js": "a3aa",
	"./game/rounds/single.store": "910e",
	"./game/rounds/single.store.js": "910e",
	"./global": "cc75",
	"./global/": "cc75",
	"./global/analytics.store": "db6d",
	"./global/analytics.store.js": "db6d",
	"./global/api.store": "f9d0",
	"./global/api.store.js": "f9d0",
	"./global/assets.store": "c1c0",
	"./global/assets.store.js": "c1c0",
	"./global/index": "cc75",
	"./global/index.js": "cc75",
	"./global/modal.store": "07d9",
	"./global/modal.store.js": "07d9",
	"./hmr": "2360",
	"./hmr.js": "2360",
	"./index": "4360",
	"./index.js": "4360",
	"./mutations": "0439",
	"./mutations.js": "0439",
	"./sound": "1a73",
	"./sound/": "1a73",
	"./sound/fx.store": "c625",
	"./sound/fx.store.js": "c625",
	"./sound/index": "1a73",
	"./sound/index.js": "1a73",
	"./sound/music.store": "c6b1",
	"./sound/music.store.js": "c6b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b85";